
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Forces a reflow/repaint of the DOM element
 * Useful for components like maps that need to know their container size
 */
export function forceReflow(element: HTMLElement | null) {
  if (!element) return;
  // Reading offsetHeight causes a reflow
  const reflow = element.offsetHeight;
  return reflow;
}

